import type { AuthResponse } from './types';

const AUTH_KEY = '@ANOVA_USER';

export function loadAuth(): AuthResponse | null {
  const raw = localStorage.getItem(AUTH_KEY);
  return raw ? (JSON.parse(raw) as AuthResponse) : null;
}

export function getAccessToken(): string | null {
  const auth = loadAuth();
  return auth?.accessToken || null;
}

export function saveAuth(auth: AuthResponse) {
  localStorage.setItem(AUTH_KEY, JSON.stringify(auth));
}

export function clearAuth() {
  localStorage.removeItem(AUTH_KEY);
}
